/* src/app/shared/contract/contract-item/contract-natio-nego/contract-natio-nego.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.item {
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  width: 100%;
  max-width: 100%;
  overflow: auto;
}
.item-content {
  display: flex;
  justify-content: space-between;
  font: 400 12px FranceTV Brown;
}
.item-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
.item-header .discountCode {
  width: 50px;
}
.item-header .discountLabel {
  width: 200px;
}
.item-header .date-range {
  width: 160px;
}
.item-header .ca {
  width: 100px;
}
.item-options {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 500px;
  max-width: 75%;
  overflow-y: auto;
}
.item-options .option-type-icon {
  height: 16px;
  width: 30px;
}
.item-options .option-value {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 2px;
  width: 200px;
}
.item-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}
.item-actions mat-icon {
  cursor: pointer;
  color: #616161;
  height: 20px;
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: black;
}
.mat-expansion-panel-body {
  padding: 0 0 16px !important;
}
/*# sourceMappingURL=contract-natio-nego.component.css.map */
